import * as React from "react";
import { forwardRef } from "react";
const SvgPause = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 8 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0H3V10H0V0ZM5 0H8V10H5V0Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgPause);
export default ForwardRef;
